
import React, { useState } from 'react';
import { Collapse, Row, Col, Checkbox, Select } from 'antd';
import { useSelector } from 'react-redux';

const { Option } = Select;

export default function CategoriesCollapse({ selectedCategories = [], onChange, onGoalSelected }) {
    const categoriesState = useSelector((state) => state.categories);
    const [selectedGoals, setSelectedGoals] = useState([]);
    const selectedCategoriesArray = Array.isArray(selectedCategories) ? selectedCategories : [];

    const handleCheckboxChange = (category, e) => {
        const checked = e.target.checked;
        onChange(category.cat_code, checked);
    };

    const handleGoalsChange = (goals) => {
        setSelectedGoals(goals);
        if (onGoalSelected) onGoalSelected(27, goals);
    };

    return (
        <>
            <Collapse
                defaultActiveKey={['1']}
                style={{ backgroundColor: 'white', marginBottom: '16px' }}
            >
                <Collapse.Panel header="Categories" key="1">
                    <Row gutter={[8, 8]}>
                        {Object.values(categoriesState.value || {})
                            .sort((a, b) => a.cat_name_eng.localeCompare(b.cat_name_eng))
                            .map((category) => (
                                <Col span={8} key={category.cat_code}>
                                    <Checkbox
                                        checked={selectedCategoriesArray.includes(category.cat_code)}
                                        onChange={(e) => handleCheckboxChange(category, e)}
                                    >
                                        {category.cat_name_eng}
                                    </Checkbox>
                                    {category.cat_code === 27 && selectedCategoriesArray.includes(27) && (
                                        <div style={{ marginTop: 8 }}>
                                            <Select
                                                mode="multiple"
                                                allowClear
                                                style={{ width: '100%' }}
                                                placeholder="Select SDG Goals"
                                                value={selectedGoals}
                                                onChange={handleGoalsChange}
                                            >
                                                {Array.from({ length: 17 }, (_, i) => (
                                                    <Option key={String(i + 1)} value={String(i + 1)}>
                                                        SDG{i + 1}
                                                    </Option>
                                                ))}
                                            </Select>
                                        </div>
                                    )}
                                </Col>
                            ))}
                    </Row>
                </Collapse.Panel>
            </Collapse>
        </>
    );
}
